export default {
  on: {
    pageInit: function () {
      var amtInput = document.getElementById('amount');
      var feeRow = document.getElementById('wdFeeRow');
      var reqAmt = document.getElementById('wdReqAmt');
      var feeAmt = document.getElementById('wdFeeAmt');
      var netAmt = document.getElementById('wdNetAmt');
      var submitSub = document.getElementById('wdSubmitSub');
      var submitNet = document.getElementById('wdSubmitNet');
      function usd(n) {
        return '$' + Number(n).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      if (amtInput) {
        amtInput.addEventListener('input', function () {
          var val = parseFloat(this.value);
          if (!isNaN(val) && val > 0) {
            var fee = val * 0.1;
            var net = val - fee;
            reqAmt.textContent = usd(val);
            feeAmt.textContent = '\u2212' + usd(fee);
            netAmt.textContent = usd(net);
            feeRow.style.display = 'block';
            submitNet.textContent = usd(net);
            submitSub.style.display = '';
          } else {
            feeRow.style.display = 'none';
            submitSub.style.display = 'none';
          }
        });
      }
    }
  },
  id: 'f84ac3d139',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page wd" data-name="invest-withdraw">\n\n    <!-- Navbar -->\n    <div class="navbar wd__navbar no-shadow">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back wd__back" aria-label="Back">\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\n          </a>\n        </div>\n        <div class="title wd__navbar-title">Withdraw</div>\n        <div class="right"></div>\n      </div>\n    </div>\n\n    <div class="page-content wd__content">\n\n      <!-- \u2500\u2500 Unavailable gate (weekend / no active investment) \u2500\u2500 -->\n      <div class="wd__gate" style="display:none;">\n        <div class="wd__gate-card">\n          <span class="wd__gate-halo"></span>\n          <div class="wd__gate-icon">\n            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ff6b5c" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="9.5"/><line x1="5.3" y1="5.3" x2="18.7" y2="18.7"/></svg>\n          </div>\n          <h2 class="wd__gate-title">Withdrawal Unavailable</h2>\n          <p class="wd__gate-sub">Withdrawals are currently not available.</p>\n          <a href="/invest/" class="wd__gate-cta" style="display:none;">\n            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>\n            Start Investing\n          </a>\n        </div>\n      </div>\n\n      <!-- \u2500\u2500 Withdrawal body \u2500\u2500 -->\n      <div class="wd__body">\n\n        <!-- Balance card -->\n        <div class="wd__balance">\n          <span class="wd__balance-shine"></span>\n          <div class="wd__balance-glow"></div>\n          <div class="wd__balance-label">\n            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4z"/></svg>\n            Withdrawable Balance\n          </div>\n          <div class="wd__balance-amount wallet--amount">$0.00</div>\n          <div class="wd__balance-note wd-balST">Withdrawal opens once your balance reaches the minimum threshold.</div>\n          <div class="wd__balance-foot">\n            <span class="wd__balance-tag">\n              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>\n              Mon\u2013Fri only\n            </span>\n            <span class="wd__balance-tag">\n              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>\n              Secure payout\n            </span>\n          </div>\n        </div>\n\n        <form name="investWithFrm" id="investWithFrm" method="post" action="" autocomplete="off">\n          <input type="hidden" name="wallet">\n          <input type="hidden" name="method" id="wdMethod" value="bank">\n          <input type="hidden" name="network" id="wdNetwork" value="">\n          <input type="hidden" name="beneficiaryID" id="wdBeneficiaryID" value="">\n          <input type="hidden" name="withdrawType" id="wdType" value="investment">\n\n          <!-- Step 1 \xB7 source + amount -->\n          <div class="wd__sec-title"><span class="wd__step-n">1</span>What to Withdraw</div>\n          <div class="wd__card">\n            <!-- Source toggle -->\n            <div class="wd__field">\n              <label class="wd__field-lbl">Withdraw From</label>\n              <div class="wd__src">\n                <button type="button" class="wd__src-tab wd__src-tab--on" data-src="investment">\n                  <span class="wd__src-ico"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 9v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9"/><polyline points="8 8 12 4 16 8"/><line x1="12" y1="4" x2="12" y2="15"/></svg></span>\n                  <span class="wd__src-name">Investment</span>\n                </button>\n                <button type="button" class="wd__src-tab" data-src="commission">\n                  <span class="wd__src-ico"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg></span>\n                  <span class="wd__src-name">Commission</span>\n                </button>\n              </div>\n            </div>\n            <!-- Investment selector (investment source) -->\n            <div class="wd__field wd__inv-field">\n              <label class="wd__field-lbl">Select Investment</label>\n              <select name="investmentSelect" id="investmentSelect"></select>\n            </div>\n            <!-- Commission balance (commission source) -->\n            <div class="wd__field wd__comm-field" style="display:none;">\n              <label class="wd__field-lbl">Network Commission</label>\n              <div class="wd__comm-box">\n                <span class="wd__comm-ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg></span>\n                <span class="wd__comm-txt">Available commission balance</span>\n                <b class="wd__comm-val wd-commission-bal">$0.00</b>\n              </div>\n            </div>\n            <div class="wd__field" style="margin-bottom:0;">\n              <label class="wd__field-lbl">Enter Amount</label>\n              <div class="wd__amount">\n                <span class="wd__amount-cur">$</span>\n                <input type="number" name="amount" id="amount" class="wd__amount-input" min="10" placeholder="0.00" required validate>\n                <button type="button" class="wd__amount-max">MAX</button>\n              </div>\n              <div class="wd__fee-row" id="wdFeeRow" style="display:none;">\n                <div class="wd__fee-line">\n                  <span class="wd__fee-line-lbl">Withdrawal Amount</span>\n                  <span class="wd__fee-line-val" id="wdReqAmt">$0.00</span>\n                </div>\n                <div class="wd__fee-line">\n                  <span class="wd__fee-line-lbl">Processing Fee <em class="wd__fee-em">(10%)</em></span>\n                  <span class="wd__fee-line-val wd__fee-line-val--fee" id="wdFeeAmt">\u2212$0.00</span>\n                </div>\n                <div class="wd__fee-divider"></div>\n                <div class="wd__fee-line wd__fee-line--net">\n                  <span class="wd__fee-line-lbl wd__fee-line-lbl--net">\n                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>\n                    You Receive\n                  </span>\n                  <span class="wd__fee-line-val wd__fee-line-val--net" id="wdNetAmt">$0.00</span>\n                </div>\n              </div>\n              <div class="wd__inr" style="display:none;">\n                <span class="wd__inr-amt">\u2248 <b class="wd-payableINR">\u20B90</b></span>\n                <span class="wd__inr-rate">1 USD = \u20B9<span class="wd-usdInrRate">\u2014</span></span>\n              </div>\n            </div>\n          </div>\n\n          <!-- Step 2 \xB7 method -->\n          <div class="wd__sec-title"><span class="wd__step-n">2</span>Payout Method</div>\n          <div class="wd__card">\n            <div class="wd__methods">\n              <button type="button" class="wd__method wd__method--on" data-method="bank" data-scope="IN">\n                <span class="wd__method-ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 21 7 3 7"/><line x1="6" y1="10" x2="6" y2="17"/><line x1="10" y1="10" x2="10" y2="17"/><line x1="14" y1="10" x2="14" y2="17"/><line x1="18" y1="10" x2="18" y2="17"/><line x1="4" y1="20" x2="20" y2="20"/></svg></span>\n                <span class="wd__method-name">Bank</span>\n                <span class="wd__method-tag">India</span>\n              </button>\n              <button type="button" class="wd__method" data-method="upi" data-scope="IN">\n                <span class="wd__method-ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><line x1="14" y1="14" x2="14" y2="21"/><line x1="18" y1="14" x2="21" y2="14"/><line x1="21" y1="14" x2="21" y2="21"/><line x1="14" y1="18" x2="18" y2="18"/></svg></span>\n                <span class="wd__method-name">UPI</span>\n                <span class="wd__method-tag">India</span>\n              </button>\n              <button type="button" class="wd__method" data-method="crypto" data-scope="ALL">\n                <span class="wd__method-ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M14.5 9.2a2.3 2.3 0 0 0-2.3-1.7H11a2.3 2.3 0 0 0 0 4.6h2a2.3 2.3 0 0 1 0 4.6h-1.2a2.3 2.3 0 0 1-2.3-1.7"/><line x1="12" y1="5.6" x2="12" y2="7.3"/><line x1="12" y1="16.7" x2="12" y2="18.4"/></svg></span>\n                <span class="wd__method-name">USDT</span>\n                <span class="wd__method-tag">Global</span>\n              </button>\n            </div>\n\n            <!-- Saved payout accounts for the active method (rendered by routes.js) -->\n            <div class="wd__payout">\n              <div class="wd__payout-head">\n                <span class="wd__payout-title">Payout Account</span>\n              </div>\n              <div class="wd__bene-list"></div>\n              <div class="wd__bene-form-wrap"></div>\n            </div>\n          </div>\n\n          <p class="wd__timetxt w-timetxt"></p>\n        </form>\n\n        <button type="button" class="withdrawMoney wd__submit disabled">\n          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>\n          <span class="wd__submit-body">\n            <span class="wd__submit-txt">Request Withdrawal</span>\n            <span class="wd__submit-sub" id="wdSubmitSub" style="display:none;">You\'ll receive <b id="wdSubmitNet">$0.00</b></span>\n          </span>\n        </button>\n\n        <!-- Withdrawal rules -->\n        <div class="wd__info">\n          <div class="wd__info-row">\n            <span class="wd__info-ico">\n              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>\n            </span>\n            <div class="wd__info-txt">\n              <p>Add &amp; save a payout account for your chosen method \u2014 you can only withdraw to a <b>saved account</b>.</p>\n              <p><b>Bank &amp; UPI</b> are available for <b>India</b> users; <b>USDT (TRC-20 / BEP-20)</b> is available <b>globally</b>.</p>\n              <p>Requests are processed on <b>weekdays only (Mon\u2013Fri)</b> \u2014 none on Sat &amp; Sun.</p>\n              <p>Funds settle within <b>24 hours</b> of approval. Minimum withdrawal is <b>$10</b>. A <b>10% processing fee</b> is deducted from the requested amount.</p>\n            </div>\n          </div>\n        </div>\n\n      </div>\n      <div class="wd__end-gap"></div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ════════ WITHDRAW PAGE (wd__*) ════════ */
.wd { background: #0A0A0B !important; }
.wd__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px calc(40px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.wd__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.wd__navbar .navbar-bg { background: transparent !important; }
.wd__navbar-title { color: var(--gold) !important; font-weight: 700; }
.wd__back { color: rgba(201,169,105,0.85) !important; }

/* ── Gate (premium block) ── */
.wd__gate { padding: 30px 6px; }
.wd__gate-card {
  position: relative; overflow: hidden; text-align: center;
  background: linear-gradient(160deg, #181410 0%, #121010 100%);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 24px; padding: 40px 26px 34px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 22px 50px -26px rgba(0,0,0,0.85);
}
.wd__gate-halo {
  position: absolute; top: -60px; left: 50%; transform: translateX(-50%);
  width: 200px; height: 200px; border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(255,107,92,0.16), transparent 65%);
}
.wd__gate-icon {
  position: relative; z-index: 1;
  width: 80px; height: 80px; border-radius: 50%; margin: 0 auto 20px;
  background: radial-gradient(circle, rgba(255,107,92,0.16), rgba(255,107,92,0.04));
  border: 1.5px solid rgba(255,107,92,0.30);
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 0 8px rgba(255,107,92,0.05);
}
.wd__gate-title { position: relative; z-index: 1; font-size: 20px; font-weight: 800; color: #fff; margin: 0; letter-spacing: -0.01em; }
.wd__gate-sub { position: relative; z-index: 1; font-size: 13px; color: rgba(255,255,255,0.52); margin: 10px auto 0; line-height: 1.6; max-width: 290px; }
.wd__gate-cta {
  position: relative; z-index: 1;
  display: inline-flex; align-items: center; gap: 7px; margin-top: 22px;
  padding: 12px 24px; border-radius: 13px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 14px; font-weight: 800;
  box-shadow: 0 10px 26px -8px rgba(201,169,105,0.6), inset 0 1px 0 rgba(255,255,255,0.4);
}
.wd__gate-cta:active { transform: scale(0.97); }

/* ── Balance card ── */
.wd__balance {
  position: relative; overflow: hidden;
  background:
    radial-gradient(100% 100% at 100% 0%, rgba(201,169,105,0.16) 0%, transparent 55%),
    linear-gradient(150deg, #221b0d 0%, #161109 55%, #1a150c 100%);
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 22px; padding: 20px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.20), 0 16px 36px -18px rgba(0,0,0,0.8);
}
.wd__balance::before {
  content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.75), transparent);
}
@keyframes wd-shine { 0% { transform: translateX(-130%) skewX(-18deg); } 100% { transform: translateX(420%) skewX(-18deg); } }
.wd__balance-shine {
  position: absolute; top: 0; bottom: 0; width: 40%; pointer-events: none;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.05), transparent);
  animation: wd-shine 5.5s ease-in-out infinite 1.5s;
}
.wd__balance-glow {
  position: absolute; top: -50px; right: -40px; width: 170px; height: 170px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.16), transparent 65%);
}
.wd__balance-label {
  position: relative; z-index: 1;
  display: flex; align-items: center; gap: 6px;
  font-size: 11.5px; font-weight: 500; color: rgba(255,255,255,0.45);
  text-transform: uppercase; letter-spacing: 0.04em;
}
.wd__balance-label svg { color: rgba(201,169,105,0.7); }
.wd__balance-amount {
  position: relative; z-index: 1;
  font-size: 34px; font-weight: 800; color: #fff; letter-spacing: -0.02em;
  line-height: 1; margin: 9px 0 9px;
}
.wd__balance-note { position: relative; z-index: 1; font-size: 11.5px; color: rgba(255,255,255,0.45); line-height: 1.5; }
.wd__balance-note.text-color-blue { color: #dfc288 !important; }
.wd__balance-foot { position: relative; z-index: 1; display: flex; gap: 8px; margin-top: 14px; }
.wd__balance-tag {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 10px; border-radius: 9px;
  background: rgba(201,169,105,0.10); border: 1px solid rgba(201,169,105,0.18);
  font-size: 10.5px; font-weight: 600; color: rgba(223,194,136,0.92);
}
.wd__balance-tag svg { color: #C9A969; }

/* ── Notice / warning ── */
.wd__notice {
  display: flex; align-items: flex-start; gap: 11px;
  margin-top: 14px; padding: 13px 14px;
  background: linear-gradient(150deg, rgba(255,107,92,0.10), rgba(255,107,92,0.03));
  border: 1px solid rgba(255,107,92,0.24); border-radius: 15px;
}
.wd__notice.hidden { display: none; }
.wd__notice-ico {
  flex-shrink: 0; width: 30px; height: 30px; border-radius: 9px;
  background: rgba(255,107,92,0.12); border: 1px solid rgba(255,107,92,0.22);
  display: flex; align-items: center; justify-content: center; color: #ff6b5c;
}
.wd__notice-txt { font-size: 12px; color: rgba(255,255,255,0.62); line-height: 1.55; margin: 0; }
.wd__notice-txt b { color: #ff8b7c; font-weight: 700; }

/* ── Section title ── */
.wd__sec-title {
  display: flex; align-items: center; gap: 9px;
  font-size: 12px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase;
  color: rgba(201,169,105,0.65); margin: 20px 4px 11px;
}
.wd__step-n {
  width: 20px; height: 20px; border-radius: 50%; flex-shrink: 0;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.14); border: 1px solid rgba(201,169,105,0.3);
  color: #dfc288; font-size: 11px; font-weight: 800;
}

/* ── Withdrawal source toggle ── */
.wd__src { display: flex; gap: 8px; }
.wd__src-tab {
  flex: 1; min-width: 0; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 7px;
  padding: 12px 8px; border-radius: 13px;
  background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.07);
  color: rgba(255,255,255,0.7); font-size: 13px; font-weight: 700;
  transition: background .16s ease, border-color .16s ease, color .16s ease;
}
.wd__src-ico { display: flex; color: rgba(201,169,105,0.75); }
.wd__src-tab--on {
  background: linear-gradient(155deg, rgba(201,169,105,0.18), rgba(201,169,105,0.05));
  border-color: rgba(201,169,105,0.5); color: #fff;
}
.wd__src-tab--on .wd__src-ico { color: #dfc288; }
.wd__src-tab--disabled { opacity: 0.4; pointer-events: none; }

/* ── Commission balance box ── */
.wd__comm-box {
  display: flex; align-items: center; gap: 10px; padding: 13px 14px; border-radius: 13px;
  background: linear-gradient(150deg, rgba(201,169,105,0.12), rgba(201,169,105,0.03));
  border: 1px solid rgba(201,169,105,0.22);
}
.wd__comm-ico {
  width: 34px; height: 34px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.12); border: 1px solid rgba(201,169,105,0.24); color: #dfc288;
}
.wd__comm-txt { flex: 1; min-width: 0; font-size: 12px; color: rgba(255,255,255,0.6); }
.wd__comm-val { font-size: 17px; font-weight: 800; color: #dfc288; flex-shrink: 0; }

/* ── MAX chip on amount ── */
.wd__amount-max {
  flex: 0 0 auto; width: auto; height: 30px; line-height: 1;
  border: 1px solid rgba(201,169,105,0.3); background: rgba(201,169,105,0.1);
  color: #dfc288; font-size: 10.5px; font-weight: 800; letter-spacing: 0.04em;
  padding: 0 11px; border-radius: 8px; cursor: pointer;
}
.wd__amount-max:active { transform: scale(0.94); }

/* ── Payout accounts (beneficiaries) ── */
.wd__payout { margin-top: 16px; }
.wd__payout-head { display: flex; align-items: center; justify-content: space-between; margin: 0 2px 10px; }
.wd__payout-title { font-size: 11px; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: rgba(201,169,105,0.78); }
/* dashed "add account" button (rendered inside the list / empty state) */
.wd__bene-add-btn {
  width: 100%; height: 46px; margin-top: 11px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 7px;
  border: 1.4px dashed rgba(201,169,105,0.4); border-radius: 13px;
  background: rgba(201,169,105,0.06); color: #dfc288; font-size: 13px; font-weight: 700;
}
.wd__bene-add-btn:active { transform: scale(0.99); background: rgba(201,169,105,0.12); }
.wd__bene-empty .wd__bene-add-btn { margin-top: 14px; }

.wd__bene-list { display: flex; flex-direction: column; gap: 9px; }
.wd__bene {
  position: relative; display: flex; align-items: center; gap: 12px; cursor: pointer;
  padding: 13px 13px; border-radius: 14px;
  background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.08);
  transition: border-color .16s ease, background .16s ease;
}
.wd__bene-radio { position: absolute; opacity: 0; pointer-events: none; }
.wd__bene--on { border-color: rgba(201,169,105,0.55); background: linear-gradient(155deg, rgba(201,169,105,0.14), rgba(201,169,105,0.04)); }
.wd__bene-ico {
  width: 38px; height: 38px; border-radius: 11px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.1); border: 1px solid rgba(201,169,105,0.2); color: #dfc288;
}
.wd__bene--on .wd__bene-ico { background: linear-gradient(135deg, #f3da92, #C9A969); color: #1a1206; border-color: transparent; }
.wd__bene-main { flex: 1; min-width: 0; }
.wd__bene-title { display: block; font-size: 13.5px; font-weight: 700; color: #fff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.wd__bene-sub { display: block; font-size: 11px; color: rgba(255,255,255,0.45); margin-top: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.wd__bene-check {
  width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  border: 1.5px solid rgba(255,255,255,0.18); color: transparent; transition: all .16s ease;
}
.wd__bene--on .wd__bene-check { background: #4ade80; border-color: #4ade80; color: #06320f; }
.wd__bene-del {
  width: 30px; height: 30px; border-radius: 9px; flex-shrink: 0; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  background: rgba(255,107,92,0.08); border: 1px solid rgba(255,107,92,0.2); color: #ff6b5c;
}
.wd__bene-del:active { transform: scale(0.92); }

/* empty state */
.wd__bene-empty {
  text-align: center; padding: 22px 16px; border-radius: 14px;
  background: rgba(255,255,255,0.025); border: 1.4px dashed rgba(201,169,105,0.3);
}
.wd__bene-empty-ico {
  width: 46px; height: 46px; border-radius: 13px; margin: 0 auto 11px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.08); border: 1px solid rgba(201,169,105,0.18); color: rgba(201,169,105,0.75);
}
.wd__bene-empty-txt { font-size: 12.5px; color: rgba(255,255,255,0.55); line-height: 1.5; margin: 0; }
.wd__bene-empty-txt b { color: rgba(201,169,105,0.9); }

/* inline add form */
.wd__bene-form {
  margin-top: 12px; padding: 15px 14px; border-radius: 15px;
  background: rgba(0,0,0,0.22); border: 1px solid rgba(201,169,105,0.2);
}
.wd__bene-form-title { font-size: 12.5px; font-weight: 800; color: #f3e2b6; margin: 0 0 13px; display: flex; align-items: center; gap: 7px; }
.wd__bene-form .wd__field { margin-bottom: 12px; }
.wd__bene-form .wd__field:last-of-type { margin-bottom: 0; }
.wd__bene-row { display: flex; gap: 10px; }
.wd__bene-row .wd__field { flex: 1; min-width: 0; }
.wd__net-tabs.wd__net-tabs--sm { gap: 8px; }
.wd__bene-form-actions { display: flex; gap: 9px; margin-top: 14px; }
.wd__bene-cancel {
  flex: 1; height: 46px; border-radius: 12px; cursor: pointer;
  background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.65); font-size: 13.5px; font-weight: 700;
}
.wd__bene-save {
  flex: 2; height: 46px; border: none; border-radius: 12px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 7px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 13.5px; font-weight: 800;
}
.wd__bene-save:active, .wd__bene-cancel:active { transform: scale(0.98); }
.wd__bene-save.disabled { opacity: 0.5; pointer-events: none; }

/* ── Form card ── */
.wd__card {
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.14);
  border-radius: 18px; padding: 16px 14px 14px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.10), 0 14px 30px -18px rgba(0,0,0,0.7);
}
.wd__field { margin-bottom: 14px; }
.wd__field select, .selectBeneficiaryList select { width: 100%; }
.wd__card .select2-container { width: 100% !important; display: block; }
.wd__field-lbl, .wd__sub-lbl {
  display: block; font-size: 11px; font-weight: 600; letter-spacing: 0.03em;
  text-transform: uppercase; color: rgba(201,169,105,0.78) !important; margin: 0 2px 8px;
}
/* amount + generic inputs */
.wd__amount, .wd__input {
  display: flex; align-items: center; gap: 8px;
  background: rgba(255,255,255,0.04); border: 1px solid rgba(201,169,105,0.18);
  border-radius: 13px; padding: 0 14px; height: 52px;
  transition: border-color .18s ease, background .18s ease;
}
.wd__amount:focus-within, .wd__input:focus-within { border-color: rgba(201,169,105,0.5); background: rgba(255,255,255,0.06); }
.wd__amount-cur { font-size: 18px; font-weight: 700; color: rgba(201,169,105,0.85); }
.wd__input-ico { color: rgba(201,169,105,0.7); display: flex; }
.wd__amount input, .wd__input input {
  flex: 1 1 0; width: 0; min-width: 0; background: transparent; border: none; outline: none;
  color: #fff; height: 100%; -webkit-appearance: none; appearance: none; margin: 0;
}
.wd__amount-input::-webkit-outer-spin-button, .wd__amount-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.wd__amount input { font-size: 19px; font-weight: 700; }
.wd__input input { font-size: 15px; font-weight: 600; }
.wd__amount input::placeholder, .wd__input input::placeholder { color: rgba(255,255,255,0.28); font-weight: 600; }
/* INR conversion (Bank/UPI · India) */
.wd__inr {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
  margin: 9px 2px 0; padding: 9px 12px; border-radius: 11px;
  background: rgba(201,169,105,0.07); border: 1px solid rgba(201,169,105,0.16);
}
.wd__inr-amt { font-size: 13px; color: rgba(255,255,255,0.6); }
.wd__inr-amt b { color: #dfc288; font-weight: 800; font-size: 14px; }
.wd__inr-rate { font-size: 10.5px; color: rgba(255,255,255,0.4); }
.wd__inr-rate span { color: rgba(201,169,105,0.85); font-weight: 600; }
/* ── Withdrawal fee breakdown ── */
.wd__fee-row {
  margin: 10px 2px 0; padding: 12px 14px; border-radius: 13px;
  background: rgba(0,0,0,0.2); border: 1px solid rgba(201,169,105,0.16);
}
.wd__fee-line {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
  padding: 5px 0;
}
.wd__fee-line-lbl {
  display: flex; align-items: center; gap: 5px;
  font-size: 12.5px; color: rgba(255,255,255,0.5);
}
.wd__fee-em { font-style: normal; color: rgba(255,107,92,0.75); font-size: 11px; }
.wd__fee-line-val { font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.85); }
.wd__fee-line-val--fee { color: rgba(255,107,92,0.9); }
.wd__fee-divider { height: 1px; background: rgba(201,169,105,0.14); margin: 6px 0; }
.wd__fee-line--net { padding-top: 7px; }
.wd__fee-line-lbl--net {
  font-size: 13px; font-weight: 700; color: #4ade80;
  display: flex; align-items: center; gap: 5px;
}
.wd__fee-line-lbl--net svg { color: #4ade80; }
.wd__fee-line-val--net { font-size: 15px; font-weight: 800; color: #4ade80; }

/* method selector */
.wd__methods { display: flex; gap: 8px; margin-bottom: 16px; }
.wd__method {
  flex: 1; min-width: 0; cursor: pointer;
  display: flex; flex-direction: column; align-items: center; gap: 5px;
  padding: 12px 6px 10px; border-radius: 14px;
  background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.07);
  transition: background .16s ease, border-color .16s ease, transform .16s ease;
}
.wd__method-ico {
  width: 34px; height: 34px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(201,169,105,0.08); color: rgba(201,169,105,0.85);
  transition: background .16s ease, color .16s ease;
}
.wd__method-name { font-size: 12.5px; font-weight: 700; color: rgba(255,255,255,0.78); }
.wd__method-tag { font-size: 9px; font-weight: 600; letter-spacing: 0.03em; text-transform: uppercase; color: rgba(255,255,255,0.35); }
.wd__method--on {
  background: linear-gradient(155deg, rgba(201,169,105,0.18), rgba(201,169,105,0.05));
  border-color: rgba(201,169,105,0.5);
  box-shadow: 0 8px 20px -12px rgba(201,169,105,0.7);
}
.wd__method--on .wd__method-ico { background: linear-gradient(135deg, #f3da92, #C9A969); color: #1a1206; }
.wd__method--on .wd__method-name { color: #fff; }
.wd__method--on .wd__method-tag { color: rgba(223,194,136,0.85); }

/* USDT network tabs */
.wd__net-tabs { display: flex; gap: 8px; }
.wd__net-tab {
  flex: 1; cursor: pointer; padding: 11px 8px; border-radius: 11px;
  background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.6); font-size: 12px; font-weight: 700;
  transition: all .16s ease;
}
.wd__net-tab--on {
  background: linear-gradient(155deg, rgba(201,169,105,0.18), rgba(201,169,105,0.05));
  border-color: rgba(201,169,105,0.5); color: #dfc288;
}

/* hints */
.wd__hint { font-size: 11.5px; color: rgba(255,255,255,0.45); line-height: 1.55; margin: 10px 2px 0; }
.wd__hint b { color: rgba(201,169,105,0.9); font-weight: 700; }
.wd__hint--warn { color: rgba(255,255,255,0.55); }
.wd__hint--warn b { color: #ff8b7c; }

.wd__card .list { margin: 0; background: transparent; }
.wd__card .list ul { background: transparent; }
.wd__card .list ul::before, .wd__card .list ul::after { display: none; }
.wd__card .item-content { padding-left: 0; }
.wd__card .item-inner { padding-right: 0; }
/* float-label pills: blend with dark inputs (was white) */
.wd__card .item-floating-label { background: transparent !important; color: rgba(201,169,105,0.85) !important; }
.wd__card .item-label { color: rgba(201,169,105,0.85) !important; }
.wd__card input[type="text"], .wd__card input[type="tel"], .wd__card input[type="email"],
.wd__card input[type="password"], .wd__card input[type="number"] { color: #fff !important; }

/* add beneficiary button */
.wd__add-btn {
  width: 100%; height: 46px; border-radius: 12px !important;
  border: 1px dashed rgba(201,169,105,0.4) !important; color: var(--gold) !important;
  background: rgba(201,169,105,0.05) !important; font-weight: 700; font-size: 13px;
}

/* time / weekend text */
.wd__timetxt:empty { display: none; }
.wd__timetxt {
  margin: 6px 2px 0; font-size: 11.5px; line-height: 1.5;
  color: #ff8b7c; font-weight: 600;
}

/* submit */
.wd__submit {
  width: 100%; min-height: 54px; margin: 16px 0 2px; border: none; border-radius: 15px;
  display: flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206;
  box-shadow: 0 10px 26px -8px rgba(201,169,105,0.6), inset 0 1px 0 rgba(255,255,255,0.4);
  transition: transform 0.14s, opacity 0.2s, filter 0.2s;
}
.wd__submit:active { transform: scale(0.98); }
.wd__submit.disabled { opacity: 0.45; filter: grayscale(0.3); pointer-events: none; box-shadow: none; }
.wd__submit-body { display: flex; flex-direction: column; align-items: center; gap: 2px; }
.wd__submit-txt { font-size: 15px; font-weight: 800; }
.wd__submit-sub { font-size: 11.5px; font-weight: 600; opacity: 0.75; }
.wd__submit-sub b { font-weight: 800; opacity: 1; }

/* ── Info card ── */
.wd__info {
  margin-top: 16px;
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.12);
  border-radius: 18px; padding: 0;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.10), 0 12px 28px -18px rgba(0,0,0,0.7);
}
.wd__info-row { display: flex; align-items: flex-start; gap: 12px; padding: 16px; }
.wd__info-ico {
  width: 36px; height: 36px; border-radius: 11px; flex-shrink: 0;
  background: rgba(201,169,105,0.08); border: 1px solid rgba(201,169,105,0.16);
  display: flex; align-items: center; justify-content: center; color: #C9A969;
}
.wd__info-txt { flex: 1; min-width: 0; }
.wd__info-txt p { font-size: 12px; color: rgba(255,255,255,0.55); line-height: 1.6; margin: 0 0 6px; padding-left: 13px; position: relative; }
.wd__info-txt p::before { content: ''; position: absolute; left: 0; top: 8px; width: 5px; height: 5px; border-radius: 50%; background: rgba(201,169,105,0.6); }
.wd__info-txt p:last-child { margin-bottom: 0; }
.wd__info-txt b { color: rgba(201,169,105,0.90); font-weight: 700; }

.wd__end-gap { height: 40px; }
`,
  styleScoped: false
};